<template>
	<div class="page page-content">
		<section>
			<div class="container col-lg-11">
				<card type="info" style="margin-top: 150px;">
					<div class="row align-items center">
						<div class="col-sm-auto col-md-1">
							<div class="container">
								<div class="row row-grid align-items-center d-none d-md-block">
									<img src="../assets/icons/globe.png" alt="" width="66px" height="66px" >
								</div>
							</div>
						</div>
						<div class="col-md-11">
							<div class="row row-grid align-items">
								<div class="col-md-4">
									<h6 class="mt-2 text-white text-uppercase text-center"><strong>Last block</strong></h6>
									<h6 class="mt-2 text-white text-center"><strong>{{blockchain.lastBlock.number}}</strong></h6>
								</div>
								<div class="col-md-4">
									<h6 class="mt-2 text-white text-uppercase text-center"><strong>Transactions</strong></h6>
									<h6 class="mt-2 text-white text-center"><strong>{{blockchain.transactions}}</strong></h6>
								</div>
								<div class="col-md-4">
									<h6 class="mt-2 text-white text-center">Network Difficult</h6>
									<h6 class="mt-2 text-white text-center">{{blockchain.difficulty}}</h6>
								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11">
				<div class="row align-items center">
					<div class="col-md-6 order-lg-1">
						<card class="mt-5 border-0" type="info" body-classes="px-0 py-1">
							<div class="pl-0">
								<div class="container">
									<div class="row row-grid align-items">
										<div class="col-sm-6">
											<img src="../assets/icons/cubes.png" style="width: 15px; padding-top: 2px;" align="left">
											<h6 class="text-white text-uppercase px-4 text-left mb-0"><strong>Blocks</strong></h6>
										</div>
									</div>
								</div>
							</div>
						</card>

						<card class="shadow-sm--hover mt-2 border-0" type="secondary" body-classes="py-2" v-for="b in blocks" :key="b.hash">
							<div class="pl-0">
								<dl class="row mb-0">
									<dt class="col-sm-6">
										<img src="../assets/icons/cube.png" align="left" style="width: 12px; padding-top: 3px;">
										<router-link :to="'/block/' + b.block">
											<h6 class="text-left px-3"><strong class="text-info">{{b.block}}</strong></h6>
										</router-link>
									</dt>
									<dt class="col-sm-6">
										<img src="../assets/icons/hourglass.png" align="left" style="width: 12px; padding-top: 3px;">
										<p class="text-muted text-left text-truncate px-1 mb-0">{{b.receiptDate | moment("from", "now")}}</p>
									</dt>
									<dt class="col-sm-6">
										<p class="text-muted text-left mb-0">{{b.count}} txns</p>
									</dt>
								</dl>
							</div>
						</card>
					</div>
					<div class="col-md-6 order-lg-2">
						<card class="mt-5 border-0" type="info" body-classes="py-1 px-0">
							<div class="pl-0">
								<div class="container">
									<div class="row row-grid align-items">
										<div class="col-md-6">
											<img src="../assets/icons/bars.png" style="width: 15px; padding-top: 2px;" align="left">
											<h6 class="text-white text-uppercase px-4 text-left text-truncate mb-0"><strong>Transactions</strong></h6>
										</div>
									</div>
								</div>
							</div>
						</card>

						<card class="shadow-sm--hover mt-2 border-0" type="secondary" body-classes="py-2" v-for="t in transactions" :key="t._id">
							<div class="pl-0">
								<dl class="row mb-0">
									<dt class="col-sm-6">
										<img src="../assets/icons/arrows.png" align="left" style="width: 12px; padding-top: 3px;">
										<h6 class="text-left pl-2 text-truncate mb-0"><strong>TX# </strong>
											<router-link :to="'/tx/' + t.hash">
												<strong class="text-info">{{t.hash}}</strong>
											</router-link>
										</h6>
									</dt>
									<dt class="col-sm-6">
										<dl class="row mb-0">
											<dt class="col-sm-4">
											<h6 class="text-muted  text-left text-truncate mb-0">From</h6>
											</dt>
											<dt class="col-sm-8">
												<router-link :to="'/address/' + t.from">
													<h6 class="text-left text-truncate text-info ">{{t.from}}</h6>
												</router-link>
											</dt>
										</dl>
									</dt>
									<dt class="col-sm-6">
										<p class="text-muted text-left text-truncate pl-4 mb-0">{{$globalConverter(t.value)}}</p>
									</dt>
									<dt class="col-sm-6">
										<dl class="row mb-0">
											<dt class="col-sm-4">
											<h6 class="text-muted text-left">To</h6>
											</dt>
											<dt class="col-sm-8">
												<router-link :to="'/address/' + t.to">
													<h6 class="text-left text-truncate text-info">{{t.to}}</h6>
												</router-link>
											</dt>
										</dl>
									</dt>
								</dl>
							</div>
						</card>
					</div>
				</div>
			</div>
		</section>
		<br>
	</div>
</template>

<script>
export default {
  name: 'home',
  components: {},
  data () {
    return {
      blocks: [],
      transactions: [],
      blockchain: {
        lastBlock: {
          number: ''
        }
      }
    }
  },
  methods: {
    routeHash (txHash) {
      console.log(txHash.value)
    }
  },
  mounted () {
    this.$http
      .get('get-transactions')
      .then(res => {
        return res.json()
      })
      .then(data => {
        for (let i = 0; i < data.result.length; i++) {
          this.transactions.push(data.result[i])
        }
      }, response => {
        return response.error
      })

    this.$http
      .get('get-blockchain-info')
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.blockchain = data
      }, response => {
        return response.error
      })

    this.$http
      .get('get-blocks-info')
      .then(res => {
        return res.json()
      })
      .then(data => {
        for (let i = 0; i < data.result.length; i++) {
          this.blocks.push(data.result[i])
        }
      }, response => {
        return response.error
      })
  }
}
</script>

<style>
</style>
